import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';

import { PartTypes, isNil } from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';

const partTypesData = {
  [PartTypes.New]: { title: I.t('PART_TYPE_NEW'), className: 'success' },
  [PartTypes.Used]: { title: I.t('PART_TYPE_USED'), className: 'danger' },
  [PartTypes.Imitation]: {
    title: I.t('PART_TYPE_IMITATION'),
    className: 'warning',
  },
};

class FinalStep extends React.Component {
  render() {
    if (isNil(this.props.bid)) return false;

    let partType = LookupsHelper.getDescription(
      'partTypes',
      this.props.bid.PartTypeID
    );
    return (
      <div>
        <div className="note note-info">
          {I.t('OFFER_CHOSEN_FOR')}
          <span className={`label label-${partTypesData[partType].className}`}>
            {partTypesData[partType].title}
          </span>
          {this.props.partDescription}
        </div>
      </div>
    );
  }
}

FinalStep.propTypes = {
  bid: PropTypes.object,
  garageData: PropTypes.object,
  partDescription: PropTypes.string,
};

export default FinalStep;
